'use client';

import { useCallback, useEffect } from 'react';
import { BestType } from '@diritto/common/best/constants';
import { CategoryNavigationMenu } from '@diritto/common/navigation/constant';
import { TrackingEventType } from '@diritto/common/tracker/tracking-event.constant';
import { Color } from '@diritto/common/style/color';
import { useTrackingState } from 'contexts/TrackingProvider';
import { RankingSeriesNavigationBar } from 'app-components/common/navigations/RankingSeriesNavigationBar';
import { RankingContentListView } from 'app-components/contents/RankingContentList';
import { RankingTab } from 'app-components/ranking/RankingTab';
import { Divider } from 'ui-components/common/Divider';
import { StyledTopMenu } from 'ui-components/navigations/styles';
import { InfoFilledIcon } from 'icons/InfoFilledIcon';
import { useHomeSettingState } from 'contexts/HomeSettingProvider';

export const RankingPage = ({
  categoryNavMenu,
  categoryId,
  bestType,
}: {
  categoryNavMenu: CategoryNavigationMenu;
  categoryId: number | undefined;
  bestType: BestType;
}) => {
  const { tracker } = useTrackingState();
  const { categoryIds: favoriteCategoryIds } = useHomeSettingState();

  useEffect(() => {
    tracker.track(TrackingEventType.ViewRanking, { categoryMenu: categoryNavMenu, bestType });
  }, [tracker, bestType, categoryNavMenu]);

  const renderFavoriteCategoryBar = useCallback(() => {
    if (categoryNavMenu !== CategoryNavigationMenu.All || favoriteCategoryIds.length === 0) {
      return null;
    }

    return (
      <div className="inline-flex justify-start items-center h-12 px-4 gap-1 bg-slate-50 overflow-hidden">
        <InfoFilledIcon className="w-4 h-4" color={Color.Gray600} />
        <div className="justify-start text-gray-700 text-xxxs font-medium">
          선호 장르에 맞춰 전체 탭이 구성되었어요.
        </div>
      </div>
    );
  }, [favoriteCategoryIds, categoryId]);

  return (
    <>
      <StyledTopMenu>
        <RankingSeriesNavigationBar selectedMenu={categoryNavMenu} />
        <Divider />
      </StyledTopMenu>
      {renderFavoriteCategoryBar()}
      <RankingTab className="flex justify-center my-4 mb-6" categoryNavMenu={categoryNavMenu} bestType={bestType} />
      <RankingContentListView categoryId={categoryId} bestType={bestType} />
    </>
  );
};
